import { render, staticRenderFns } from "./SsoAccept.vue?vue&type=template&id=814ae2f6"
import script from "./SsoAccept.vue?vue&type=script&lang=js"
export * from "./SsoAccept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports